module.exports = __webpack_public_path__ + "img/16-02.e4e56eba.png";